"use client";

import { useTranslations } from "use-intl";

import { PhoneOtpPrimaryAction } from "@/components/PhoneOtpPrimaryAction";
import { Button } from "@/components/ui/button";

interface PhoneOtpActionsProps {
  code: string;
  hasSentCode: boolean;
  resendSeconds: number;
  sending: boolean;
  showPrimaryAction: boolean;
  verifying: boolean;
  onSendCode: () => Promise<void>;
  onVerifyCode: () => Promise<void>;
}

/** Renders the default OTP actions while allowing a parent flow to own the primary action. */
export function PhoneOtpActions(props: PhoneOtpActionsProps) {
  const t = useTranslations("globals.auth");

  return (
    <div className="flex flex-wrap gap-2">
      <PhoneOtpPrimaryAction
        code={props.code}
        hasSentCode={props.hasSentCode}
        sending={props.sending}
        show={props.showPrimaryAction}
        verifying={props.verifying}
        onSendCode={props.onSendCode}
        onVerifyCode={props.onVerifyCode}
      />
      {props.hasSentCode ? (
        <Button
          type="button"
          variant="ghost"
          disabled={props.sending || props.resendSeconds > 0}
          onClick={props.onSendCode}
        >
          {props.resendSeconds > 0
            ? t("resendPhoneCodeIn", { seconds: props.resendSeconds })
            : t("resendPhoneCode")}
        </Button>
      ) : null}
    </div>
  );
}
